export const ASSIGNMNET_STATUS = {
  noAssignment: 0,
  someStudentsAssigned: 1,
  allStudentAssigned: 2,
};
